// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"65624502","4573":"c509a3ce","7234":"a2d21c44"}[chunkId] + ".chunk.css";
};